var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0H6.5C2.912 0.006 0.006 2.912 0 6.5V17.5C0.006 21.088 2.912 23.994 6.5 24H17.5C21.088 23.994 23.994 21.088 24 17.5V6.5C23.994 2.912 21.088 0.006 17.5 0ZM12 17.5C8.962 17.5 6.5 15.038 6.5 12C6.5 8.962 8.962 6.5 12 6.5C15.038 6.5 17.5 8.962 17.5 12C17.5 15.038 15.038 17.5 12 17.5ZM18.5 6.5C17.672 6.5 17 5.828 17 5C17 4.172 17.672 3.5 18.5 3.5C19.328 3.5 20 4.172 20 5C20 5.828 19.328 6.5 18.5 6.5Z",
    fill: "#CCE8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b90106044b2facc69634f8ca61133777.svg";
export { ForwardRef as ReactComponent };